import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Home, Wallet, Star, Gift, History, Settings, Bell, Gamepad2, Dice1, Trophy } from "lucide-react";

export default function JoyCasinoMain() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [browserTheme, setBrowserTheme] = useState('dark');

  useEffect(() => {
    const dataParam = searchParams.get('data');
    const themeParam = searchParams.get('theme');
    if (themeParam) setBrowserTheme(themeParam);
    if (dataParam) { 
      try { 
        setData(JSON.parse(decodeURIComponent(dataParam))); 
      } catch (e) {
        console.error('Parse error:', e);
      } 
    }
    document.title = 'JoyCasino - Онлайн казино';
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = '/joycasino-favicon.svg';
  }, [searchParams]);

  if (!data) return <div className="min-h-screen bg-[#1a0a2e] flex items-center justify-center text-white">Загрузка...</div>;

  const isDark = browserTheme === 'dark';
  const theme = { bg: isDark ? '#202124' : '#dee1e6', activeTabBg: isDark ? '#292a2d' : '#ffffff', inactiveTabBg: isDark ? '#35363a' : '#c9cdd4', addressBarBg: isDark ? '#292a2d' : '#ffffff', addressInputBg: isDark ? '#202124' : '#f1f3f4', textPrimary: isDark ? '#e8eaed' : '#202124', textSecondary: isDark ? '#9aa0a6' : '#5f6368', border: isDark ? '#3c4043' : '#dadce0' };
  const accountName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Игрок';
  const userId = data.visibleId || '0000000';
  const balance = parseFloat(data.balance || 0);
  const bonusBalance = parseFloat(data.bonusBalance || 0);
  const freeSpins = parseInt(data.freeSpins || 0);

  const menuItems = [
    { icon: Home, label: 'Главная', active: true }, { icon: Gamepad2, label: 'Слоты', active: false },
    { icon: Dice1, label: 'Live Казино', active: false }, { icon: Trophy, label: 'Турниры', active: false },
    { icon: Wallet, label: 'Касса', active: false }, { icon: History, label: 'История', active: false },
    { icon: Gift, label: 'Бонусы', active: false }, { icon: Settings, label: 'Настройки', active: false },
  ];

  const popularGames = [
    { name: 'Book of Ra', img: '📕', provider: 'Novomatic' },
    { name: 'Sweet Bonanza', img: '🍬', provider: 'Pragmatic' },
    { name: 'Gates of Olympus', img: '⚡', provider: 'Pragmatic' },
    { name: 'Big Bass Bonanza', img: '🐟', provider: 'Pragmatic' },
  ];

  const BrowserFrame = () => (
    <div style={{ backgroundColor: theme.bg }} className="flex-shrink-0">
      <div className="flex items-center h-[38px]">
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.inactiveTabBg }}>
            <img src="/ozon-favicon.ico" alt="" className="w-4 h-4 mr-2" /><span className="text-[13px] truncate" style={{ color: theme.textSecondary }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.activeTabBg }}>
            <img src="/joycasino-favicon.svg" alt="" className="w-4 h-4 mr-2" /><span className="text-[13px] truncate" style={{ color: theme.textPrimary }}>JoyCasino</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center ml-1 mb-1" style={{ color: theme.textSecondary }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg></button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: theme.addressBarBg }}>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: theme.addressInputBg, border: `1px solid ${theme.border}` }}>
          <svg className="w-4 h-4 mr-3" style={{ color: theme.textSecondary }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: theme.textPrimary }}>joycasino.ru</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col template-preview-scale" style={{ backgroundColor: theme.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <BrowserFrame />
      <div className="flex-1 flex bg-gradient-to-b from-[#1a0a2e] to-[#0d0518]">
        <aside className="w-56 bg-[#1a0a2e]/80 flex flex-col flex-shrink-0 border-r border-[#9333EA]/20">
          <div className="p-4"><img src="/joycasino-logo.svg" alt="JoyCasino" className="h-8" /></div>
          <nav className="flex-1 py-2">
            {menuItems.map((item, i) => { const Icon = item.icon; return (
              <a key={i} href="#" className={`flex items-center gap-3 px-4 py-2.5 text-sm ${item.active ? 'text-[#9333EA] bg-[#9333EA]/10' : 'text-gray-400 hover:bg-white/5'}`}>
                <Icon className="w-5 h-5" /><span>{item.label}</span>
              </a>
            ); })}
          </nav>
        </aside>
        <div className="flex-1 flex flex-col min-w-0">
          <header className="bg-[#1a0a2e]/80 border-b border-[#9333EA]/20 px-6 py-3 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-[#9333EA]/10 border border-[#9333EA]/30 rounded-lg px-4 py-2">
                <div className="text-xs text-gray-400">Баланс</div>
                <div className="text-lg font-bold text-white">{balance.toLocaleString('ru-RU')} ₽</div>
              </div>
              <div className="bg-[#FFD700]/10 border border-[#FFD700]/30 rounded-lg px-4 py-2">
                <div className="text-xs text-gray-400">Бонусы</div>
                <div className="text-lg font-bold text-[#FFD700]">{bonusBalance.toLocaleString('ru-RU')} ₽</div>
              </div>
              <div className="bg-[#00D4AA]/10 border border-[#00D4AA]/30 rounded-lg px-4 py-2">
                <div className="text-xs text-gray-400">Фриспины</div>
                <div className="text-lg font-bold text-[#00D4AA]">{freeSpins}</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <button className="p-2 text-gray-400 relative"><Bell className="w-5 h-5" /><span className="absolute top-1 right-1 w-2 h-2 bg-[#9333EA] rounded-full"></span></button>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-gradient-to-br from-[#9333EA] to-[#7C3AED] rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-bold">{accountName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}</span>
                </div>
                <div><div className="text-sm font-medium text-white">{accountName}</div><div className="text-xs text-gray-500">ID: {userId}</div></div>
              </div>
            </div>
          </header>
          <main className="flex-1 p-6 overflow-auto">
            <div className="bg-gradient-to-r from-[#9333EA] to-[#7C3AED] rounded-2xl p-6 mb-6 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <h2 className="text-2xl font-bold text-white mb-2">🎰 Бонус на первый депозит</h2>
              <p className="text-white/80 mb-4">До 200 000 ₽ + 500 фриспинов!</p>
              <button className="px-6 py-2.5 bg-[#FFD700] text-[#1a0a2e] rounded-lg font-bold hover:bg-[#FFC000]">Получить бонус</button>
            </div>
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2"><Star className="w-5 h-5 text-[#FFD700]" /> Популярные игры</h3>
            <div className="grid grid-cols-4 gap-4 mb-6">
              {popularGames.map((game, i) => (
                <div key={i} className="bg-[#1a0a2e] border border-[#9333EA]/20 rounded-xl p-4 hover:border-[#9333EA]/50 cursor-pointer group">
                  <div className="text-5xl mb-3 text-center group-hover:scale-110 transition-transform">{game.img}</div>
                  <div className="text-white font-medium text-center">{game.name}</div>
                  <div className="text-xs text-gray-500 text-center">{game.provider}</div>
                </div>
              ))}
            </div>
            <div className="bg-[#1a0a2e] border border-[#9333EA]/20 rounded-xl p-5">
              <h3 className="font-medium text-white mb-4">Последние игры</h3>
              {(data.games || []).slice(0, 3).map((g, i) => (
                <div key={i} className="flex items-center justify-between py-3 border-b border-[#9333EA]/10 last:border-0">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#9333EA]/20 rounded-lg flex items-center justify-center text-xl">🎰</div>
                    <div><div className="text-sm font-medium text-white">{g.name}</div><div className="text-xs text-gray-500">{g.date} {g.time}</div></div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-gray-500">Ставка: {g.bet} ₽</div>
                    <div className={`font-medium ${parseFloat(g.win || 0) > 0 ? 'text-[#00D4AA]' : 'text-gray-400'}`}>{parseFloat(g.win || 0) > 0 ? `+${g.win}` : '0'} ₽</div>
                  </div>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
